/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Translation from './internationalization-store.js'

class Module {

    constructor(catalog_uid , picture , screen_uid , style_type  , translationID  , uid , submodules , index , isValid , exam_catalog_uid){
        this.catalog_uid = catalog_uid;
        this.picturePath = picture;
        this.screenID = screen_uid;
        this.translationID = translationID;
        this.uid = uid;
        this.exam_catalog_uid = exam_catalog_uid;
        this.color = style_type;
        this.index = index || "";
        this.isValid = isValid;
        this.subModules = (submodules || [] ).map(function(object){
            var module = object.module;
            return new Module(module.catalog_uid , module.picture ,  module.screen_uid , module.style_type , module.title ,  module.uid  ,  object.subModules , module.index , module.isValid)
        });
    }

    getName(){

        if (this.index == null || this.index == undefined){
            this.index = "";
        }

        return Translation.getModule(this.translationID , 'Missing Unit Translation')
        
    }

    get Catalog(){
        return this.catalog_uid
    }
}

class ScreensStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.modules = {};
    }


    processModules(data){

        var allModules = {};


        for(var key in data){
            if(key == "newToken") continue;
            if(key == "timeTakenServer") continue;
            if(!data.hasOwnProperty(key)) continue;

            var module = data[key].module;
            allModules[module.uid] = new Module(module.catalog_uid , module.picture ,  module.screen_uid , module.style_type , module.title ,  module.uid  ,  data[key].subModules , module.index , module.isValid , module.exam_catalog_uid);

        }

        return allModules
    }

    _registerToActions(action) {

        switch(action.actionType)
        {
            case "UPDATE_SCREEN_MODULES":
                this.modules = this.processModules(action.response);
                this.emitChange();
                break;
        }

    }
    getArray(){
        return Object.keys(this.modules).map(function(k) { return this.modules[k] }.bind(this));
    }

}

export default new ScreensStore();